import { render, staticRenderFns } from "./DefaultContainerListaVez.vue?vue&type=template&id=0b81ada0&"
import script from "./DefaultContainerListaVez.vue?vue&type=script&lang=js&"
export * from "./DefaultContainerListaVez.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports